import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = "http://hdeng2024.cafe24.com/api/controller/admin/faq";

export const adminFaqApiSlice = createApi({
  reducerPath: "adminFaqApiSlice",
  baseQuery: fetchBaseQuery({ baseUrl: baseUrl }),
  endpoints: (builder) => ({
    // FAQ 리스트 가져오기
    getFaqList : builder.mutation({
        query : (param : {page : any, size : number, keyword : string, sortColumn : string, sortOrder : string}) => {
            return{
            url : `/getFaqList.php?page=${param.page}&size=${param.size}&keyword=${param.keyword}&sortColumn=${param.sortColumn}&sortOrder=${param.sortOrder}`
            }
        }
    }),
    // FAQ 등록
    setFaq : builder.mutation({
        query: (body : any) => {
            return{
                url : '/setFaqs.php', method : 'post', body
            }
        }
    }),
    // FAQ 상세보기
    getFaqDetail : builder.mutation({
        query : (param : {idx:any}) => {
            return{
                url : `/getFaqDetails.php?faq_idx=${param.idx}`
            }
        }
    }),
    // FAQ 수정
    updFaq : builder.mutation({
        query : (body : any) => {
            return{
                url : '/updFaqs.php', method : 'post', body
            }
        }
    }),
    // FAQ 공개여부 수정
    updFaqActiveStatus : builder.mutation({
        query : (body : any) => {
            return{
                url : '/updFaqActiveStatus.php', method : 'post', body
            }
        }
    })
  }),
});

export const {
    useGetFaqListMutation, useSetFaqMutation, useGetFaqDetailMutation, useUpdFaqMutation, useUpdFaqActiveStatusMutation
} = adminFaqApiSlice;